import React, { useEffect, useMemo, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useCookies } from "react-cookie";
import "./UserLandingPage.css";
import CourseParticipantCard from "./CourseParticipantCard";
import cardIconOne from "../../../assets/images/user-landing-page/cardIconOne.svg";
import cardIconTwo from "../../../assets/images/user-landing-page/cardIconTwo.svg";
import cardIconThree from "../../../assets/images/user-landing-page/cardIconThree.png";
import CourseCard from "./CourseCard";
import { fetchFinalAssessments, getCourses } from "ServerAPI/serverAPI";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { courseTypes } from "constants/Constants";
import UserLandingPageCard from "./UserLandingPageCard";
import completedCourseIcon from "../../../assets/images/user-landing-page/completed-course-icon.svg";
import inProgressCourseIcon from "../../../assets/images/user-landing-page/inprogress-course-icon.svg";
import Certification from "../../../assets/images/user-landing-page/cerification-icon.svg";
import AssessmentCard from "./AssessmentCard";
import Assessments from "./Assessments";
import Courses from "./Courses";

const CourseParticipant = () => {
  const [cookies] = useCookies();
  const [activeCourseTab, setActiveCourseTab] = useState(1);
  const [allCourses, setAllCourses] = useState([]);
  const [coursesInProgress, setCoursesInProgress] = useState([]);
  const [completedCourses, setCompletedCourses] = useState([]);
  const [newCourses, setNewCourses] = useState([]);
  const [progressCourseNames, setProgressCourseNames] = useState([]);
  const [completedCoursesNames, setCompletedCoursesNames] = useState([]);
  const [newCoursesNames, setNewCoursesNames] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [ongoingCourses, setOngoingCourses] = useState([]);
  const [courseType, setCourseType] = useState("");
  const [numberOfCompletedCourses, setNumberOfCompletedCourses] = useState(0);
  const [numberOfInprogressCourses, setNumberOfInprogressCourses] = useState(0);
  const [numberOfCertifications, setNumberOfCertifications] = useState(0);
  const [allFinalAssessments, setAllFinalAssessments] = useState([]);
  const courseCategoryCardData = [
    {
      title: "Completed",
      value: numberOfCompletedCourses,
      icon: completedCourseIcon,
    },
    {
      title: "In Progress",
      value: numberOfInprogressCourses,
      icon: inProgressCourseIcon,
    },
    {
      title: "Certifications",
      value: numberOfCertifications,
      icon: Certification,
    },
  ];
  const features = Array.isArray(cookies.features) ? cookies.features : [];
  const hasProgressTracking = features.some(
    (feature) => feature.featureName === "Progress Tracking"
  );

  const navigate = useNavigate();

  const categoriesCourses = (allCourses) => {
    const today = new Date();

    const progressCourses = allCourses.filter((course) => {
      const startDate = new Date(course?.startDate);
      const endDate = new Date(course?.endDate);
      return today >= startDate && !course?.courseProgress?.completed;
    });

    const coursesCompelted = allCourses.filter((course) => {
      const startDate = new Date(course?.startDate);
      const endDate = new Date(course?.endDate);
      return course?.courseProgress?.completed;
    });

    const newlyAddedCourse = allCourses.filter((course) => {
      const startDate = new Date(course?.startDate);
      const endDate = new Date(course?.endDate);
      return today < startDate;
    });
    progressCourses.forEach((course) => {
      setProgressCourseNames((pre) => {
        return [...pre, course?.courseTitle];
      });
    });
    coursesCompelted.forEach((course) => {
      setCompletedCoursesNames((pre) => {
        return [...pre, course?.courseTitle];
      });
    });

    newlyAddedCourse.forEach((course) => {
      setNewCoursesNames((pre) => {
        return [...pre, course?.courseTitle];
      });
    });
    setNewCourses(newlyAddedCourse);
    setCoursesInProgress(progressCourses);
    setCompletedCourses(coursesCompelted);
    setOngoingCourses([...progressCourses]);
    setNumberOfCertifications(coursesCompelted?.length);
    setNumberOfCompletedCourses(coursesCompelted?.length);
    setNumberOfInprogressCourses(progressCourses?.length);
  };
  const fetchCourses = async () => {
    setIsLoading(true);
    const response = await getCourses(
      cookies.email,
      cookies.roleId,
      cookies.organizationId,
      cookies.department,
      cookies.userId
    );
    if (response.status === 200) {
      categoriesCourses(response.data);
    }
    setIsLoading(false);
  };
  const handleRedirect = (path) => {
    navigate(`/view-course/${path}`);
  };
  const handleRedirect1 = () => {
    navigate(`/assessment-review/`);
  };
  useEffect(() => {
    fetchCourses();
  }, []);
  useEffect(() => {
    console.log("activeCourseTab", activeCourseTab);

    if (activeCourseTab === 1) {
      setAllCourses(ongoingCourses);
      setCourseType(courseTypes.ONGOING);
    }
    if (activeCourseTab === 2) {
      setCourseType(courseTypes.COMPLETED);
      setAllCourses(completedCourses);
    }
    if (activeCourseTab === 3) {
      setAllCourses(newCourses);
      setCourseType(courseTypes.UPCOMING);
    }
  }, [activeCourseTab, coursesInProgress, completedCourses]);
  const getFinalAssessments = async () => {
    const response = await fetchFinalAssessments(cookies.userId);

    if (response.status === 200) {
      setAllFinalAssessments(response?.data?.data?.finalAssessments);
    }
  };
  useEffect(() => {
    getFinalAssessments();
  }, []);

  return (
    <>
      <Row>
        {isLoading ? (
          <div className="d-flex justify-content-center">
            <CircularProgress />
          </div>
        ) : (
          <>
            {hasProgressTracking && (
              <>
                <Row className="">
                  {courseCategoryCardData.map((data) => {
                    return (
                      <>
                        <Col xl={4} lg={6} md={12} sm={12}>
                          <UserLandingPageCard
                            title={data?.title}
                            titleIcon={data?.icon}
                            value={data?.value}
                          />
                        </Col>
                      </>
                    );
                  })}
                </Row>
              </>
            )}

            {hasProgressTracking && (
              <>
                <div className="mt-5">
                  <Assessments finalAssessments={allFinalAssessments} />
                </div>
              </>
            )}

            <div className="mt-5">
              <Courses
                allCourses={allCourses}
                courseType={courseType}
                activeCourseTab={activeCourseTab}
                setActiveCourseTab={setActiveCourseTab}
                handleRedirect={handleRedirect}
              />
            </div>
          </>
        )}
      </Row>
    </>
  );
};

export default CourseParticipant;
